var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"app-layout-404"},[_c('el-header',{staticStyle:{"padding":"0"}},[_c('transition',{attrs:{"name":"el-fade-in-linear"}},[_c('app-header')],1)],1),_c('el-container',[_c('transition',{attrs:{"name":"el-fade-in-linear"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }